<template>
    <f7-page
        name="Admin"
        class="onboardingBg"
    >
        <f7-navbar
            large
            large-transparent
            title-large="Admin"
            inner-class="onboardingBg"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    @click="goBack"
                />
            </f7-nav-left>
            <f7-nav-title>Admin</f7-nav-title>
        </f7-navbar>
        <f7-block-title>Experiments variants</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <!-- <f7-list-item
                link="#"
                @click="setExperimentVariant('014_goals', 0, '/home')"
            >EXP 014_goals_0 No goals</f7-list-item> -->
            <f7-list-item
                link="#"
                @click="setExperimentVariant('014_goals', 1, '/onboarding/goals')"
            >EXP 014_goals_1 Full goals</f7-list-item>
            <f7-list-item
                link="#"
                @click="setExperimentVariant('014_goals', 3, '/onboarding/goals')"
            >EXP 014_goals_3 Full goals with resume module</f7-list-item>
            <f7-list-item
                link="#"
                @click="setExperimentVariant('014_goals', 2, '/home')"
            >EXP 014_goals_4 No goals distraction</f7-list-item>
            <f7-list-item
                link="#"
                @click="setExperimentVariant('015_course-nav', 0, '/home')"
            >EXP 015_course-nav on</f7-list-item>
            <f7-list-item
                link="#"
                @click="setExperimentVariant('015_course-nav', 1, '/home')"
            >EXP 015_course-nav off</f7-list-item>
        </f7-list>
        <f7-block-title>Test content</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <f7-list-item link="/start">Start page</f7-list-item>
            <f7-list-item link="/onboarding">Onboarding</f7-list-item>
            <f7-list-item link="/onboarding/goals">Goals Onboarding</f7-list-item>
            <f7-list-item
                link="#"
                @click="redoPoll()"
            >Redo Poll</f7-list-item>
            <f7-list-item link="/subscribeStart">Subscribe Screen</f7-list-item>
            <f7-list-item link="/freeViaPartner">Subscribe via Partner</f7-list-item>
            <f7-list-item link="/username">Community Onboarding</f7-list-item>
            <f7-list-item @click="goToInPopup(`/units/285`)">Pulse Redo</f7-list-item>
            <f7-list-item @click="goToInPopup(`/firstTracker`)">Pulse Delight</f7-list-item>
        </f7-list>

        <f7-block-title>Progress</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <f7-list-item
                link
                style="text-transform: capitalize"
                @click="resetProgress"
            >RESET</f7-list-item>
        </f7-list>

        <f7-block-title>Subscription ({{ user.isSubscribed ? 'Paid' : 'Free' }})</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <f7-list-item link="/subscription/test">Get all products</f7-list-item>
            <f7-list-item
                v-if="isPgap"
                @click="getProducts()"
            >Get available native SKUs</f7-list-item>
            <f7-list-item
                v-if="!user.isSubscribed"
                link
                style="text-transform: capitalize"
                @click="setSubscription('Paid')"
            >Change to Paid</f7-list-item>
            <f7-list-item
                v-else
                link
                style="text-transform: capitalize"
                @click="setSubscription('Free')"
            >Change to Free</f7-list-item>
            <f7-list-item
                v-if="isPgap && !user.isSubscribed"
                style="text-transform: capitalize"
                link
                @click="restorePurchases"
            >Restore puchases</f7-list-item>
            <f7-list-item
                style="text-transform: capitalize"
                link
                @click="checkSubscriptionStatus"
            >Check Subscription Status</f7-list-item>
            <f7-list-item
                v-if="!isPgap"
                link
                style="text-transform: capitalize"
                @click="togglePaymentMode()"
            >Payment mode {{ paymentMode }}</f7-list-item>
        </f7-list>
        <template v-if="isPgap">
            <f7-block-title>Version of the app ({{ branch }})</f7-block-title>
            <f7-list
                inset
                class="bordered"
            >
                <f7-list-item
                    link
                    style="text-transform: capitalize"
                    @click="configurePlugin('')"
                >Production</f7-list-item>
                <f7-list-item
                    link
                    style="text-transform: capitalize"
                    @click="configurePlugin('DEV')"
                >Development</f7-list-item>
                <f7-list-item
                    link
                    style="text-transform: capitalize"
                    @click="configurePlugin('FUTURE')"
                >Future</f7-list-item>
            </f7-list>
        </template>
        <f7-block-title>Push notification</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <f7-list-item
                v-if="isPgap"
                link
                style="text-transform: capitalize"
                @click="checkNativePerms"
            >TEST</f7-list-item>
            <f7-list-item
                v-if="isPgap"
                link
                style="text-transform: capitalize"
                @click="nativeNotifications"
            >ENABLE</f7-list-item>
        </f7-list>
        <f7-block-title>Dev tools</f7-block-title>
        <f7-list
            inset
            class="bordered"
        >
            <f7-list-item
                v-if="isPgap"
                @click="doVibrate();"
            >Test vibrate</f7-list-item>
            <f7-list-item
                v-if="isPgap"
                @click="reviewPrompt();"
            >Test Review</f7-list-item>
            <f7-list-item @click="testFailedRequest();">Test Failed request</f7-list-item>
            <f7-list-item
                style="text-transform: capitalize"
                link
                href="#"
                @click="enableEruda"
            >Enable Eruda</f7-list-item>
        </f7-list>
    </f7-page>
</template>

<script>
import utils from '../../js/utils';

export default {
    store: [
        'api',
        'user',
        'courses',
        'topics',
        'units',
        'trackerData',
        'onboardingCompleted',
        'unitsIndex',
        'coursesIndex',
        'topicsIndex',
        'fullDataIndex',
        'progress',
        'myTopics'
    ],
    data () {
        return {
            unlockAll: false,
            paymentMode: 'production',
            branch: 'production',
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        },
    },
    created: function () {
        this.unlockAll = localStore.getItem('adminUnlockAll') ? true : false;
        this.paymentMode = localStore.getItem('testPayment') ? 'test' : 'production';
        this.branch = localStore.getItem('branch') ? localStore.getItem('branch') : 'production';
    },
    mounted: function () { },
    methods: {
        togglePaymentMode: function () {
            if (!localStore.getItem('testPayment')) {
                localStore.setItem('testPayment', true);
                this.paymentMode = 'test';
            } else {
                localStore.removeItem('testPayment');
                this.paymentMode = 'production';
            }
            this.paymentMode
        },
        enableEruda: function () {
            if (window.eruda) return;
            var script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/eruda';
            document.head.appendChild(script);
            setTimeout(() => {
                let el = document.createElement('div');
                document.body.appendChild(el);
                window.eruda.init({
                    container: el,
                    useShadowDom: true,
                    autoScale: true
                });
            }, 1000);

        },
        redoPoll: function () {
            localStore.removeItem('last-poll');
        },
        setExperimentVariant: function (experimentId, variant, url) {
            localStore.setItem(`experiment-${experimentId}`, variant);
            setTimeout(() => {
                f7.views['main'].router.navigate(url, {
                    reloadAll: true,
                    ignoreCache: true
                });
            }, 100);
            if (experimentId !== '014_goals') return;
            this.$http.post(`${this.api}/users/${this.user.id}/topics`, {
                topicIds: [],
            }).then(
                () => {
                    this.myTopics = [];
                    console.log('topics saved');


                },
                response => {
                    console.error(response.body.message || 'Unknown error');
                }
            );
        },
        reviewPrompt: function () {
            this.$events.fire('ask-for-rating', true);
        },
        doVibrate: function () {
            if (pgap) window.Vibrate.vibrate('light');
        },
        goBack: function () {
            if (f7.views['main'].router.history.length === 1) {
                return f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
            }
            return f7.views['main'].router.back();
        },
        testFailedRequest: function () {
            this.$http.get(`${this.api}/doesntexist`).then(
                () => {
                },
                (response) => {
                    utils.failedRequest('main', response);
                }
            );
        },
        goToInPopup: function (url) {
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true,
                ignoreCache: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 550);
            // f7.statusbar.setTextColor('white');
        },
        checkSubscriptionStatus: function () {
            this.$events.fire('subscriptions-sync', () => {
                f7.popup.create({
                    content: `<div class="popup" style="overflow-y: scroll;"><br><br><p><a href="#" class="link popup-close">Close admin detail</a></p>
                                    <pre>${JSON.stringify(this.user, null, 2)}</pre></div>`,
                }).open();
            });
        },
        restorePurchases: function () {
            this.$events.fire('subscriptions-restore', () => {
            });
        },
        setAdminMode: function () {
            this.unlockAll = !this.unlockAll;
            if (this.unlockAll) localStore.setItem('adminUnlockAll', true);
            else localStore.removeItem('adminUnlockAll');
        },
        setSubscription: function (type) {
            if (type === 'Paid') {
                return f7.dialog.confirm('Are you sure you want to apply coupon "INTERNALTESTADMIN"? IF you have paid you can also restore from store. ', () => {
                    this.$http
                        .post(`${this.api}/subscriptions/coupon`, {
                            code: 'INTERNALTESTADMIN',
                        })
                        .then(
                            () => {
                                this.user.isSubscribed = true;
                                this.$events.fire('user-save');
                                f7.dialog.alert('Success! You are subscribed!');
                            },
                            e => {
                                console.error('error complete day', e);
                                this.user.isSubscribed = true;
                                this.$events.fire('user-save');
                                f7.dialog.alert('Error: Could not subscribe');
                            });
                });
            } else {
                this.$events.fire('subscriptions-cancel');
            }
        },
        configurePlugin: function (branch) {
            let options = {
                'config-file': `https://getcoral.s3.amazonaws.com/BUILDS${branch}/chcp.json`
            };
            localStore.setItem('branch', branch);
            this.branch = branch;
            localStore.removeItem('hasUpdate');
            localStore.removeItem('deeplink');
            window.chcp.configure(options, this.configureCallback);
        },
        configureCallback: function (error) {
            if (error) {
                f7.dialog.alert('Error during the configuration process');
                console.log(error.description);
            } else {
                console.log('Plugin configured successfully');
                this.checkForUpdate();
            }
        },
        checkForUpdate: function () {
            f7.toast
                .create({
                    text: `Checking for update`,
                    position: 'center',
                    closeTimeout: 1000
                })
                .open();
            window.chcp.fetchUpdate(this.fetchUpdateCallback);
        },
        fetchUpdateCallback: function (error, data) {
            if (error) {
                setTimeout(() => {
                    f7.dialog.alert('Failed to load the update with error code: ' + error.code + ' ' + error.description);
                }, 1000);
                return;
            }
            console.log('Update is loaded, running the installation', data);
            f7.toast
                .create({
                    text: `Found update`,
                    position: 'center',
                    closeTimeout: 1000
                })
                .open();
            window.chcp.installUpdate(this.installationCallback);
        },
        installationCallback: function (error) {
            if (error) {
                f7.dialog.alert(
                    'Failed to install the update with error code: ' + error.code + ' ' + error.description
                );
            } else {
                f7.dialog.alert('Update installed!');
            }
        },
        setDay: function () {
            f7.dialog.prompt('Enter day number', day => {
                this.user.day = parseFloat(day);
                this.$events.fire('user-save');
            });
        },
        resetProgress: function () {
            f7.dialog.confirm('Are you sure you want to fully reset your progress?', () => {
                window.localStore.removeItem('notifications');
                window.localStore.removeItem('notifications-push');
                window.localStore.removeItem('notifications-sms');
                window.localStore.removeItem('onboardingCompleted');
                window.localStore.removeItem('trackerTakenOnce');
                window.localStore.removeItem('coachmarkComplete');
                window.localStore.removeItem('coachmarkBookmark');
                window.localStore.removeItem('coachmarkDisabled');
                localStore.removeItem('last-poll');
                this.progress = [];
                this.myTopics = [];
                this.user.isSubscribed = false;
                this.onboardingCompleted = 0;
                this.$http.post(`${this.api}/users/${this.user.id}/reset`).then(() => {
                    this.user.currentCourseId = 223;
                    this.user.day = 0;
                    this.user.sessions = 1;
                    this.user.unitsCompleted = 0;
                    this.$events.fire('user-get');
                    this.progress = [];
                    this.courses = [];
                    this.coursesIndex = [];
                    this.topics = [];
                    this.topicsIndex = [];
                    this.units = [];
                    this.unitsIndex = [];
                    this.fullDataIndex = [];
                    this.$events.fire('reload-data-cache');
                    f7.dialog.progress('Resetting').open();
                    setTimeout(() => {
                        this.$events.fire('user-progress-fetched');
                    }, 2000);
                    setTimeout(() => {
                        this.$events.fire('get-home');
                        f7.dialog.close();
                        f7.dialog.alert('Progress has been reset');
                        // f7.views['main'].router.navigate('/home', { reloadAll: true, animate: false });
                        setTimeout(() => {
                            f7.views['main'].router.navigate('/onboarding', { reloadAll: true, animate: false });
                            //window.location.reload();
                        }, 400);
                        //
                    }, 4000);
                });
                for (let i = 0; i < this.courses.length; i++) {
                    const course = this.courses[i];
                    this.coursesIndex[course.id].unitsCompletes = 0;
                }
            });
        },
        checkNativePerms: function () {
            if (typeof PushNotification === 'undefined') return f7.dialog.alert('Not native');
            window.PushNotification.hasPermission(data => {
                let nativePerm = data.isEnabled ? 'granted' : 'not granted';
                f7.dialog.alert(nativePerm);
            });
        },
        nativeNotifications: function () {
            if (typeof PushNotification === 'undefined') return f7.dialog.alert('Not native');

            window.phonegapPush = window.PushNotification.init({
                android: {},
                browser: {
                    pushServiceURL: `${this.api}/push`
                },
                ios: {
                    alert: 'true',
                    badge: 'true',
                    sound: 'true'
                },
                windows: {}
            });

            window.phonegapPush.on('registration', data => {
                f7.dialog.prompt('data.registrationId', () => { }, () => { }, data.registrationId);
                console.log(data);
                window.localStore.setItem('pushToken', data.registrationId);

                const d = new Date();
                const timezone = d.getTimezoneOffset() * 60;
                let device_type = 0;
                // REQUIRED The device's platform:
                // 0 = iOS
                // 1 = ANDROID
                // 2 = AMAZON
                // 3 = WINDOWSPHONE (MPNS)
                // 4 = CHROME APPS / EXTENSIONS
                // 5 = CHROME WEB PUSH
                // 6 = WINDOWS (WNS)
                // 7 = SAFARI
                // 8 = FIREFOX
                // 9 = MACOS
                // 10 = ALEXA
                // 11 = EMAIL
                this.$http
                    .put(this.api + '/devices', {
                        pushToken: data.registrationId,
                        timezone,
                        appVersion: this.version,
                        device_type
                    })
                    .then(
                        response => {
                            console.log(response.body);
                        },
                        response => {
                            console.error(response);
                        }
                    );

            });

            window.phonegapPush.on('notification', data => {
                f7.popup.create({
                    content: `<div class="popup"><p><br><br><a href="#" class="link popup-close">Close admin detail</a></p>
                                    <pre>${JSON.stringify(data, null, 2)}</pre></div>`,
                }).open();
            })

            window.phonegapPush.on('error', e => {
                console.warn(e.message);
            });
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
</style>
